import { XFormFieldWrapper } from '@adornis/chemistry/elements/components/x-formfield-wrapper.js';
import { customElement, state } from 'lit/decorators.js';
import './fonts.js';

/**
 * @customElement cr-formfield-wrapper
 */
@customElement('cr-formfield-wrapper')
export class ChromiumFormFieldWrapper extends XFormFieldWrapper {
  @state() private _errorVanished = false;

  override styles() {
    return [
      ...super.styles(),

      {
        ':host [background]': {
          borderRadius: `${this.sizes.borderRadiusSecondary} ${this.sizes.borderRadiusSecondary} 0 0`,
          background: this._errorVanished ? this.colors.primary.shade(100) : this.colors.neutral.shade(50),
          borderBottom: this._errorVanished
            ? `2px solid ${this.colors.primary}`
            : `2px solid ${this.colors.neutral.shade(200)}`,
          transition: 'all 0.2s ease-in-out',
        },

        ':host [background]:hover': {
          background: 'tranparent',
          borderBottom: `2px solid ${this.colors.primary}`,
        },
        ':host([error]) [background]': {
          background: this.colors.tone.error.shade(100),
        },
        ':host([error]) [background]:hover': {
          background: this.colors.tone.error.shade(50),
          borderBottom: `2px solid ${this.colors.tone.error}`,
        },
        ':host([disabled])': {
          opacity: '.9 !important',
        },
        // 'cr-flex[wrapper] > cr-flex': {
        //   '&:hover': {

        //     borderColor: this.colors.primary.shade(300),
        //   },
        // },
        // {
        //   ':host [background]': {
        //     borderRadius: '6px',
        //     background: 'transparent',
        //     border: `2px solid #E2E2E2`,
        //     transition: 'all 0.2s ease-in-out',
        //   },
      },
      //   ':host([disabled])': {
      //     opacity: '.9 !important',
      //   },
      // },
    ];
  }

  override connectedCallback(): void {
    super.connectedCallback();

    // Watch if a possible error goes away
    const observer = new MutationObserver(mutations => {
      mutations.forEach(async mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'error') {
          if (this.getAttribute('error') === null) {
            this._errorVanished = true;
            setTimeout(() => {
              this._errorVanished = false;
            }, 3000);
          }
        }
      });
    });

    observer.observe(this, { attributes: true });
  }
}
